export const CHECKOUT_FORM_NAME = 'checkoutForm';
export const BUYER_ATTENDEE_ID = 'buyer';

export enum CheckoutFormSection {
    contactInfo = 'contactInfo',
    attendees = 'attendees',
    tosCheckbox = 'tosCheckbox',
    payment = 'payment',
}
